import { connect } from 'react-redux';
import UserDesignPage from './UnderDesignPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { rowClick } from 'src/actions/liveOrderAction';
import { downloadURL } from 'src/actions/completeOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { getUnderDesignData } from 'src/actions/manufacturAction';

export const mapStateToProps = (state: AppState) => {
    return {
        underDesignData: state.manufactur.underDesignData
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getLiveOrderData);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
            dispatch(getUnderDesignData);
        },
        reload: () => {
            dispatch(getUnderDesignData);
        },
        onRowClick: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        onDownloadClick: (filepath: string, fileName: string) => {
            dispatch(downloadURL(filepath, fileName, 'Initial Scan'));
        }
    };
};

const UnderDesignContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(UserDesignPage);

export default UnderDesignContainer;



// WEBPACK FOOTER //
// ./src/components/UnderDesign/UnderDesignContainer.tsx